import questionSelectionActions from '../actions/QuestionSelectionActions';

export default function (state = {}, action) {
    if (action.type === questionSelectionActions.types.QUESTION_SELECTION_SET_SELECTION) {
        return Object.assign({}, state, { [action.contentRevisionId]: action.selection });
    }
    if (action.type === questionSelectionActions.types.QUESTION_SELECTION_RESTORE) {
        return Object.assign({}, state, action.questionSelection);
    }
    if (action.type === questionSelectionActions.types.SET_INLINE_CB_SELECTION) {
        return { ...state, ...action.selectionData };
    }
    return state;
}
